import Section from "./base/Section";
import { theme } from "../theme.js";

export default function AboutItem({ description, showFullDescription, setShowFullDescription }) {
    const isLongDescription = description && description.length > 500;
    
    return (
        <Section title="A propos de l'événement">
            <div style={{
                ...styles.descriptionContainer,
                ...(isLongDescription && !showFullDescription ? styles.descriptionBlurred : {}),
            }}>
                <p style={styles.description}>{description}</p>
            </div>
            {isLongDescription && (
                <button 
                    onClick={() => setShowFullDescription(!showFullDescription)}
                    style={styles.toggleLink}
                >
                    {showFullDescription ? "Voir moins" : "Voir plus"}
                </button>
            )}
        </Section>
    );
}

const styles = {
  descriptionContainer: {
    position: "relative",
    overflow: "hidden",
  },
  descriptionBlurred: {
    maxHeight: "200px",
    maskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
    WebkitMaskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
  },
  description: {
    fontSize: theme.fonts.size.base,
    lineHeight: "1.8",
    color: theme.colors.textInverted,
    whiteSpace: "pre-wrap",
    margin: 0,
  },
  toggleLink: {
    backgroundColor: "transparent",
    border: "none",
    fontSize: theme.fonts.size.base,
    fontWeight: theme.fonts.weight.medium,
    color: theme.colors.textInverted,
    textDecoration: "underline",
    cursor: "pointer",
    padding: 0,
    marginTop: theme.spacing.md,
    transition: `color ${theme.transitions.base}`,
  },
}